import { Typography } from '@mui/joy'
import { ReactNode } from 'react'

type ContainerTitleProps = {
  children: ReactNode | string
}
export function ContainerTitle({ children }: ContainerTitleProps) {
  return (
    <Typography
      sx={{
        fontSize: '18px',
        fontWeight: 600,
        marginBottom: '38px',
      }}
    >
      {children}
    </Typography>
  )
}
